import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import { Button, Modal, Notice } from "../../components/design";

// isGuarantor / hideBackgroundImage only changed the old overlay background;
// the shared Modal has one backdrop for everyone.
const ProcessFailedModal = ({
  showPopup,
  isGuarantor, // eslint-disable-line no-unused-vars
  heading,
  subheading,
  closeModalState,
  hideBackgroundImage, // eslint-disable-line no-unused-vars
  buttonText,
}) => {
  const { _t } = useTranslator();
  const label = haveValue(buttonText)
    ? _t(buttonText)
    : _t("goBackAndReupload");
  return (
    <Modal
      open={!!showPopup}
      onClose={() => closeModalState(false)}
      closeLabel={_t("close")}
      icon={
        <img src="/images/high-risk-icon.svg" alt="" width={56} height={56} />
      }
      title={heading}
      description={subheading}
      actionsLayout="stack"
      actions={
        <>
          <Button size="lg" block onClick={() => closeModalState(false)}>
            {label}
          </Button>
          <Button
            variant="secondary"
            size="lg"
            block
            onClick={() => closeModalState(false)}
          >
            {label}
          </Button>
        </>
      }
    >
      <Notice tone="danger" className="text-start">
        The document has expired. Please use a valid document, such as your
        passport or another photo ID.
      </Notice>
    </Modal>
  );
};

export default ProcessFailedModal;
